import {
  message_box_styles_default
} from "./chunk.3KX77L33.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/message-box/message-box.ts
var FadvMessageBox = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "header", "footer");
    this.height = "small";
    this.scrollStart = "top";
  }
  render() {
    return $`<div class=${o({
      "message-box": true,
      "message-box--has-header": this.hasSlotController.test("header"),
      "message-box--has-footer": this.hasSlotController.test("footer")
    })} ><div class="message-box__header"><slot name="header"></slot></div><div class=${o({
      "message-box__body": true,
      "message-box__body--small": this.height === "small",
      "message-box__body--medium": this.height === "medium",
      "message-box__body--large": this.height === "large",
      "message-box__body--auto": this.height === "auto",
      "message-box__body--fill": this.height === "fill"
    })} ><fadv-scroller class="message-box__scroller" mode="opaque" scrollStart=${this.scrollStart}><slot></slot></fadv-scroller></div><div class="message-box__footer"><slot name="footer"></slot></div></div>`;
  }
};
FadvMessageBox.styles = message_box_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvMessageBox.prototype, "height", 2);
__decorateClass([
  e()
], FadvMessageBox.prototype, "scrollStart", 2);
FadvMessageBox = __decorateClass([
  n("fadv-message-box")
], FadvMessageBox);

export {
  FadvMessageBox
};
